import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  fileUploader: {
    width: "calc(100% - 32px)",
    height: 165,
    marginLeft: 32,
    marginBottom: theme.hv.spacing.xs,
  },
  hideAfterOne: {
    "&>div": {
      display: "none",
    },
  },
  description: {
    paddingLeft: 0,
  },
}));

export default styles;
